import React from 'react'
import {
    Cog6ToothIcon,
} from '@heroicons/react/24/outline'
import { useNavigate } from "react-router-dom";
import { Bezier2, Chat, Code, BarChart } from 'react-bootstrap-icons';
import { BsStars } from "react-icons/bs";
import { FiInfo } from "react-icons/fi";
import { useSelector } from 'react-redux';



const Sidebar = ({ navigation, subPageName ,data}) => {
  let navigate = useNavigate();
  const userData = useSelector((state) => state.assetLibrary.userData);
  const totalData = useSelector((state) => state.chatAi.tData);
  const uData = JSON.parse(localStorage.getItem("userData"))
  const rValues = uData?.data
  function classNames(...classes) {
      return classes.filter(Boolean).join(' ')
  }
  const RedirectionControl = (event,title) => {
    event.preventDefault();
    switch (title) {
      case "url":
        navigate("/Chat-Ai");
        break;
      case "assets":
        navigate("/Chat-Ai/assets");
        break;
      case "text":
        navigate("/Chat-Ai/text");
        break;
      case "tuning":
        navigate("/Chat-Ai/tuning");
        break;
      case "engage":
        navigate("/Chat-Ai/engage");
        break;
      case "setting":
        navigate("/Setting/setup");
        break;
      case "design":
        navigate("/Chat-Ai/design");
        break;
      case "developer":
        navigate("/Chat-Ai/developer");
        break;
      case "gettingStarted":
        navigate("/Started");
        break;
      case "query":
        navigate("/internal_ama");
        break;
      // case "token":
      //   navigate("/Setting/token");
      //   break;
      // case "meeting":
      //   navigate("/Setting/meeting");
      //   break;
      default:
        break;
    }
  };

  return (
    <div className="hidden h-[88%] lg:fixed lg:inset-y-[13%] lg:z-10 lg:flex lg:w-72 lg:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex grow flex-col gap-y-5 overflow-y-auto  bg-white px-6 pb-4">
            <div className='flex justify-between border-b border-gray-200 my-auto'>

          <div className='text-base font-[600] pt-1 pb-4  cursor-default my-auto'>Train AI</div>
          <div className='flex my-auto pt-1 pb-4'>
          {/* {data?.used_prompts >= data?.total_prompts && <FiInfo title={"You've used up all your prompts for this cycle! To continue using Zoi, please wait for the next cycle or purchase a plan with more prompts."}  className='my-auto mr-2 text-sm cursor-pointer'/>} */}


          {/* <div onClick={()=>{if(data?.used_prompts >= data?.total_prompts){navigate(`/Setting/billing`);}}} className={` ${data?.used_prompts >= data?.total_prompts ? "text-red-500 cursor-pointer" :"cursor-default"} text-sm font-[600] my-auto`}>{`${data?.used_prompts}/${data?.total_prompts}`}</div> */}
          {/* <div onClick={()=>{if(data?.used_prompts >= data?.total_prompts){navigate(`/Setting/billing`);}}} className={` ${data?.used_prompts >= data?.total_prompts ? "text-red-500 cursor-pointer" :"cursor-default"} text-sm mr-4 font-[600] my-auto`}>{`$${totalData?.total_credits}`}</div> */}
          </div>
            </div>
          {/* <div onClick={(e)=>{RedirectionControl(e, "gettingStarted");}}  className={`${subPageName === "gettingStarted" ? "bg-[var(--brand-primary)] text-white ":"text-[#49BCD2]"} flex p-2 border border-[var(--brand-primary)] cursor-pointer rounded-md`}> 
            <BsStars className='  mr-2' />
            <div className={`text-[12px] font-[700] `}>Getting Started</div>
          </div> */}
            <nav className="flex flex-1 flex-col ">
              <ul role="list" className="flex flex-1 flex-col">
                <li>
                  <ul role="list" className="-mx-2 space-y-1">
                    {navigation.map((item,index) => (
                      <li key={item.name} className='cursor-pointer'>
                        {/* {index == 0 &&<div className="text-xs ml-2 mb-2 font-semibold leading-6 text-gray-400 cursor-default">Input</div>} */}
                        <span
                          className={classNames(
                            subPageName === item.current
                              ? 'bg-gray-50 text-[var(--brand-primary)]'
                              : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50',
                            'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                          )}
                          onClick={(e)=>{RedirectionControl(e, item.current);}}
                        >
                          <item.icon
                            className={classNames(
                                subPageName === item.current ? 'text-[var(--brand-primary)]' : 'text-gray-400 group-hover:text-[var(--brand-primary)]',
                              'h-6 w-6 shrink-0'
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </span>
                        {/* {index == 3 &&<div className="text-xs ml-2 my-2 font-semibold leading-6 text-gray-400 cursor-default">Capture</div>} */}
                      </li>
                    ))}
                  </ul>

                </li>
                <div className='mt-auto'>

                {/* {rValues?.developer &&<li className="cursor-pointer">
                  <span href="/developer"
                    className={`${subPageName == "developer" ? "bg-gray-50 text-[var(--brand-primary)]" : "text-[var(--brand-secondary)]"} group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6  hover:bg-gray-50 hover:text-[var(--brand-primary)]`}
                    onClick={(e)=>{RedirectionControl(e, "developer")}}
                  >
                    <Code
                      className={`h-6 w-6 shrink-0 ${subPageName == "developer" ? "bg-gray-50 text-[var(--brand-primary)]":"text-gray-400"} group-hover:text-[var(--brand-primary)]`}
                      aria-hidden="true"
                    />
                    Developer
                  </span>
                </li>} */}
                <li className="cursor-pointer">
                  <span href="/Setting"
                    className={`${subPageName == "query" ? "bg-gray-50 text-[var(--brand-primary)]" : "text-[var(--brand-secondary)]"} group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6  hover:bg-gray-50 hover:text-[var(--brand-primary)]`}
                    onClick={(e)=>{RedirectionControl(e, "query")}}
                  >
                    <Chat
                      className={`h-6 w-6 shrink-0 ${subPageName == "query" ? "bg-gray-50 text-[var(--brand-primary)]":"text-gray-400"} group-hover:text-[var(--brand-primary)]`}
                      aria-hidden="true"
                    />
                    Ask SIA
                  </span>
                </li>
                <li className="cursor-pointer">
                  <span
                    className={`${window.location.pathname === '/Analytics' || window.location.pathname === '/analytics' ? "bg-gray-50 text-[var(--brand-primary)]" : "text-[var(--brand-secondary)]"} group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6  hover:bg-gray-50 hover:text-[var(--brand-primary)]`}
                    onClick={()=>{navigate(`/Analytics`);}}
                  >
                    <BarChart
                      className={`h-6 w-6 shrink-0 ${window.location.pathname === '/Analytics' || window.location.pathname === '/analytics' ? "bg-gray-50 text-[var(--brand-primary)]":"text-gray-400"} group-hover:text-[var(--brand-primary)]`}
                      aria-hidden="true"
                    />
                    Analytics
                  </span>
                </li>
                <li className="cursor-pointer">
                  <span href="/Setting/setup"
                    className={`${subPageName == "settings" ? "bg-gray-50 text-[var(--brand-primary)]" : "text-[var(--brand-secondary)]"} group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6  hover:bg-gray-50 hover:text-[var(--brand-primary)]`}
                    onClick={(e)=>{RedirectionControl(e, "setting")}}
                  >
                    <Cog6ToothIcon
                      className={`h-6 w-6 shrink-0 ${subPageName == "settings" ? "bg-gray-50 text-[var(--brand-primary)]":"text-gray-400"} group-hover:text-[var(--brand-primary)]`}
                      aria-hidden="true"
                    />
                    Settings
                  </span>
                </li>
                </div>

              </ul>
            </nav>
          </div>
        </div>
  )
}

export default Sidebar